import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Youtube, Twitter, Instagram, Share2 } from "lucide-react";
import { SOCIALS } from "../mock";
import { Logo } from "./Logo";

const ICONS = {
  facebook: Facebook,
  youtube: Youtube,
  twitter: Twitter,
  instagram: Instagram,
};

const Footer = () => {
  return (
    <footer className="relative z-10 border-t border-white/10 bg-[#2a2a2a]">
      <div className="mx-auto max-w-6xl px-4 py-12 md:px-8">
        <div className="flex flex-col items-center gap-6 text-center">
          <Link
            to="/subscribe"
            className="rounded bg-[#e0a82e] px-8 py-3 font-display text-lg font-600 uppercase tracking-widest text-[#1c1c1c] transition-colors duration-200 hover:bg-[#f2b93f]"
          >
            Subscribe
          </Link>

          <div className="flex items-center gap-2 text-[#c8c8c8]">
            <Share2 className="h-4 w-4 text-[#e0a82e]" />
            <span className="font-display text-sm uppercase tracking-widest">
              Don't forget to share this site
            </span>
          </div>

          <div className="flex items-center gap-5">
            {SOCIALS.map((s) => {
              const Icon = ICONS[s.icon];
              return (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={s.label}
                  className="rounded-full border border-white/15 p-2.5 text-[#d0d0d0] transition-all duration-200 hover:border-[#e0a82e] hover:text-[#e0a82e]"
                >
                  <Icon className="h-5 w-5" />
                </a>
              );
            })}
          </div>

          <div className="mt-4 flex flex-col items-center gap-2">
            <Logo className="h-16 w-16" />
            <div className="flex items-center gap-4">
              <Link to="/privacy-policy" className="text-xs uppercase tracking-wide text-[#b0b0b0] transition-colors hover:text-[#e0a82e]">
                Privacy Policy
              </Link>
              <span className="text-[#555]">|</span>
              <Link to="/disclaimer" className="text-xs uppercase tracking-wide text-[#b0b0b0] transition-colors hover:text-[#e0a82e]">
                Disclaimer
              </Link>
            </div>
            <p className="text-xs text-[#8f8f8f]">
              &copy; {new Date().getFullYear()} Incarcerated. Imprisonment in Australia &mdash; locate, search and chat.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
